import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { InternalCommentsContainer } from 'components/order/comments/InternalCommentsContainer';
import React from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export const InternalCommentsPage: React.FC = () => {
  return (
    <AccessControlCheck allowedPermissions={[ePermissions.CommentsRead]}>
      <InternalCommentsContainer />
    </AccessControlCheck>
  );
};
